import { Box, Typography, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import useLessonAssignment from 'state/providers/LessonAssignmentProvider';
import { translate } from 'translations/translator';
import { calcDuration } from 'util/assignment-util';
import { StepThreeLessonCard } from './StepThreeLessonCard';
import { StepOneAssignmentAlerts } from './StepOneAssignmentAlerts';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatUiDate } from 'util/date-util';
import CommonTranslationVariant from 'translations/variants/common';
import LessonAssignmentTranslationVariant from 'translations/variants/lessonAssignment';

const getTranslation = key => translate('lessonPlanner', key);
const translateAssignment = (key: LessonAssignmentTranslationVariant) =>
  translate('lessonAssignment', key);
const translateCommon = (key: CommonTranslationVariant) => translate('common', key);

export const StepThreeLessonActivities = () => {
  const [{ stepOneFormState }, { stepperDispatch }] = useLessonAssignment();
  const classes = useStyles()();
  const formData: any = Object.values(stepOneFormState.form);

  const handleEditActivities = () => {
    stepperDispatch.setActiveStep(1);
  };

  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 5 }}>
        1. {getTranslation('lessonsAndActivities')}
      </Typography>
      {formData?.map(
        (x, idx) =>
          x.assigned && (
            <Container key={`activity-container-${idx}`} className={classes.lessonContainer}>
              <Box key={`activity-title-container-${idx}`} className={classes.lessonTitle}>
                <Box display="flex" flexDirection="column">
                  <Typography
                    key={`activity-title-${idx}`}
                    variant="h4"
                    style={{ margin: '10px 0 5px' }}
                  >
                    {x.title ?? x.lesson.title}
                  </Typography>
                  <Box display="flex" key={`activity-subtitle-${idx}`}>
                    <Typography variant="body1">
                      {translateCommon(CommonTranslationVariant.startdate)}:{' '}
                      <span style={{ color: '#6A6A6A', marginRight: 10 }}>
                        {formatUiDate(new Date(x.startDate))}
                      </span>
                    </Typography>
                    <Typography variant="body1">
                      {x?.dueDate &&
                        `${translateAssignment(LessonAssignmentTranslationVariant.dueDate)}: `}
                      {x?.dueDate && (
                        <span style={{ color: '#6A6A6A', marginRight: 10 }}>
                          {formatUiDate(new Date(x.dueDate))}
                        </span>
                      )}
                    </Typography>
                    <Typography variant="body1">
                      {getTranslation('duration')}:{' '}
                      <span style={{ color: '#6A6A6A', marginRight: 10 }}>
                        {calcDuration(x)} {getTranslation('minutes')}
                      </span>
                    </Typography>
                    <Typography variant="body1">
                      {x?.instructions && `${getTranslation('instructions')}: `}
                      {x?.instructions && (
                        <span style={{ color: '#6A6A6A' }}>{x?.instructions}</span>
                      )}
                    </Typography>
                  </Box>
                </Box>
                <HwtButton
                  onClick={handleEditActivities}
                  variant="outlined"
                  style={{ width: '150px' }}
                >
                  <FontAwesomeIcon icon={faPencil} size="sm" style={{ marginRight: 10 }} />
                  {translateCommon(CommonTranslationVariant.edit)}
                </HwtButton>
              </Box>
              <Box>
                {x.lesson.sections.map((s, sIdx) => (
                  <StepThreeLessonCard
                    key={`activity-card-${sIdx}`}
                    title={s.title}
                    activities={s.activities}
                  />
                ))}
              </Box>
              <Box display="flex">
                <StepOneAssignmentAlerts
                  style={{ margin: '0px 0px 20px' }}
                  type={'duration'}
                  duration={calcDuration(x)}
                />
              </Box>
            </Container>
          )
      )}
    </Box>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    lessonContainer: {
      border: '1px solid #DBDBDB',
      borderRadius: '5px',
      marginBottom: '10px',
      width: '100% !important'
    },
    lessonTitle: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      margin: '30px 0px'
    }
  }));
